var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": { maxWidth: _vm.getMaxWidth, minWidth: _vm.getMinWidth },
        "no-backdrop-dismiss": "",
        "no-esc-dismiss": ""
      },
      model: {
        value: _vm.show_preview,
        callback: function($$v) {
          _vm.show_preview = $$v
        },
        expression: "show_preview"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    _vm.show_preview = false
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n\t\t\t\t" + _vm._s(_vm.$t(_vm.game_name)) + "\n\t\t\t"
                )
              ])
            ],
            1
          ),
          _c("div", { staticClass: "layout-padding" }, [
            _c("div", { staticClass: "row q-pa-xs" }, [
              _c("p", { staticClass: "col-12 text-bold" }, [
                _vm._v(_vm._s(_vm.$t("game_preview")))
              ]),
              !_vm.game_finished
                ? _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c("p", { staticClass: "col-5 text-bold text-center" }, [
                        _vm._v(_vm._s(_vm.$t("this")))
                      ]),
                      _c("div", { staticClass: "col-2" }),
                      _c("p", { staticClass: "col-5 text-bold text-center" }, [
                        _vm._v(_vm._s(_vm.$t("that")))
                      ]),
                      _vm._l(_vm.options, function(option, index) {
                        return _c(
                          "div",
                          {
                            key: "o-" + index,
                            staticClass: "row q-ma-sm full-width flex"
                          },
                          [
                            _c(
                              "q-card",
                              {
                                staticClass:
                                  "q-pa-sm justify-center col-5 cursor-pointer",
                                class: _vm.getThisStyle(option),
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.setAnswer(option, 1)
                                  }
                                }
                              },
                              [
                                _c(
                                  "q-card-main",
                                  { staticClass: "text-center" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(option.this.text) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "q-card",
                              {
                                staticClass: "q-pa-sm justify-center col-2",
                                attrs: { flat: "" }
                              },
                              [
                                _c(
                                  "q-card-title",
                                  { staticClass: "text-center" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(option.question) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "q-card",
                              {
                                staticClass:
                                  "q-pa-sm justify-center col-5 cursor-pointer",
                                class: _vm.getThatStyle(option),
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.setAnswer(option, 2)
                                  }
                                }
                              },
                              [
                                _c(
                                  "q-card-main",
                                  { staticClass: "text-center" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t" +
                                        _vm._s(option.that.text) +
                                        "\n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm.game_finished
                ? _c(
                    "div",
                    { staticClass: "col-10 q-mt-lg" },
                    [
                      _c("p", { staticClass: "text-bold q-mt-sm" }, [
                        _vm._v(_vm._s(_vm.$t("result")))
                      ]),
                      _c("q-slider", {
                        attrs: {
                          disable: "",
                          markers: "",
                          snap: "",
                          color: _vm.game_finished
                            ? _vm.getSliderColor()
                            : "blue-6",
                          min: 0,
                          max: _vm.number_of_choices
                        },
                        model: {
                          value: _vm.user_score,
                          callback: function($$v) {
                            _vm.user_score = $$v
                          },
                          expression: "user_score"
                        }
                      }),
                      _c("p", { staticClass: "q-mt-sm" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.$t("correct_answers") +
                                ": " +
                                _vm.user_score +
                                " / " +
                                _vm.number_of_choices
                            ) +
                            "\n\t\t\t\t\t"
                        )
                      ]),
                      _vm.user_won
                        ? _c("p", [_vm._v(_vm._s(_vm.$t(_vm.success_message)))])
                        : _c("p", [_vm._v(_vm._s(_vm.$t(_vm.failure_message)))])
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _c("div", { staticClass: "col-xs-12 q-mt-md" }, [
              _c(
                "div",
                { staticClass: "row justify-end" },
                [
                  _c("q-btn", {
                    attrs: { color: "secondary", label: _vm.$t("back") },
                    on: {
                      click: function($event) {
                        _vm.show_preview = false
                      }
                    }
                  }),
                  _vm.game_finished
                    ? _c("q-btn", {
                        staticClass: "q-ml-md",
                        attrs: {
                          color: "primary",
                          label: _vm.$t("play_again")
                        },
                        on: { click: _vm.resetGame }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }